import { Box, Typography, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as BGLeft } from "../assets/Login-BgLeft.svg";
import { ReactComponent as BGRight } from "../assets/Login-BgRight.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    backgroundColor: "#303030",
    position: "relative",
    overflow: "hidden",
  },
  backgroundImage: {
    height: "100%",
    width: "auto",
    zIndex: 0,
    position: "absolute",
  },
  contentContainer: {
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  title: {
    color: "#FFFFFF",
    fontSize: "28px",
    fontWeight: "700",
    lineHeight: "31px",
    letterSpacing: "0px",
    textAlign: "center",
    marginBottom: "16px",
  },
  description: {
    color: "#FFFFFF",
    textAlign: "center",
    maxWidth: "650px",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0.17000000178813934px",
    marginBottom: "180px",
  },
}));

interface ErrorPageProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}

export const ErrorPage = (props: ErrorPageProps) => {
  const classes = useStyles();
  const { title, description } = props;

  return (
    <Stack minHeight={550} className={classes.root} id="main">
      <BGLeft className={classes.backgroundImage} style={{ left: "0", bottom: "0" }} />
      <BGRight className={classes.backgroundImage} style={{ right: "0", top: "0" }} />
      <Box className={classes.contentContainer}>
        <Typography variant="h4" component="h4" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body1" className={classes.description}>
          {description}
        </Typography>
      </Box>
    </Stack>
  );
};
